import { FontAwesomeIcon } from "./FontAwesomeIcon"
import { faGlobeEurope } from "@fortawesome/free-solid-svg-icons"

export const GlobeEurope = (props) => {
  return <FontAwesomeIcon faIcon={faGlobeEurope} {...props} />
}
